// De Position voor een dashboardkaart die bovenaan moet komen. Puur.
//
// Nodig omdat een kaart die je via 'Aanpassen' toevoegt of terugzet achteraan
// kwam (aantal kaarten + 1), ver onder de vouw (testronde 2026-10-13, B7). Het
// dashboard sorteert oplopend op Position, dus bovenaan is één lager dan de
// laagste die er al is — ook als dat nul of negatief wordt; slepen nummert de
// kaarten daarna weer netjes vanaf 1.

/**
 * @param {Array<*>} positions - Position van de kaarten die er al zijn
 * @returns {number}
 */
const positionAtTop = (positions) => {
    const numbers = (positions || [])
        .filter((p) => p !== '' && p !== null && p !== undefined)
        .map(Number)
        .filter(Number.isFinite)
    return numbers.length === 0 ? 1 : Math.min(...numbers) - 1
}

export default positionAtTop
